'use client'

import { ReactNode, useState } from 'react'
import { IconAlertTriangleFilled } from '@tabler/icons-react'
import clsx from 'clsx'

import Button from 'shared/ui/Button'
import { Modal } from 'shared/ui/Modal'
import { Tooltip } from 'shared/ui/Tooltip'
import { isNilOrEmpty } from 'shared/utils/ramda'

import { useDeliverySupport } from '../../providers/DeliverySupportContext'

import styles from './DeliveryAreaSummary.module.scss'

interface DeliveryAreaSummaryProps {
  // Delivery area check shown in the modal, above the close button.
  children: ReactNode
}

const DeliveryAreaSummary = ({ children }: DeliveryAreaSummaryProps) => {
  const [open, setOpen] = useState(false)
  const { postalCodeAndCityContext } = useDeliverySupport()

  const handleOpen = () => setOpen(true)

  const handleClose = () => {
    setOpen(false)
  }

  const unsupportedAlertMessage = postalCodeAndCityContext?.isSupported
    ? ''
    : isNilOrEmpty(postalCodeAndCityContext)
      ? 'Nie podano kodu pocztowego dla najlepszego dopasowania produktów'
      : 'Przykro nam, na chwilę obecną nie dowozimy pod wskazany adres'

  return (
    <>
      <Button
        className={styles.postalCodeWrapper}
        onClick={handleOpen}
        aria-haspopup='true'
        aria-controls='modalPostalCode'
        aria-expanded={open}
        tabIndex={0}
        variant='neutralOutline'
        size='large'
        aria-label={`Kod Pocztowy${unsupportedAlertMessage ? `: ${unsupportedAlertMessage}` : ''}`}
      >
        <div className={styles.postalCodeTitle}>Kod Pocztowy</div>
        {unsupportedAlertMessage && (
          <div
            className={clsx(styles.warning, {
              [styles.warningUnset]: isNilOrEmpty(postalCodeAndCityContext)
            })}
          >
            <Tooltip
              id='postal-code-warning-tooltip'
              title={unsupportedAlertMessage}
            >
              <IconAlertTriangleFilled />
            </Tooltip>
          </div>
        )}

        <div className={styles.postalCodeLabel}>
          {postalCodeAndCityContext?.postalCode || 'podaj kod pocztowy'}
        </div>
      </Button>
      <div className={styles.modalWrapper}>
        <Modal open={open} onClose={handleClose} id='modalPostalCode'>
          <>
            {children}
            <Button
              fullWidth
              variant='primary'
              onClick={handleClose}
              tabIndex={0}
            >
              Zamknij
            </Button>
          </>
        </Modal>
      </div>
    </>
  )
}

export default DeliveryAreaSummary
